import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SelectMenuContext } from '../context';
import styles from '@dtsl/css-select-menu/dist/index.module.css';
function GroupSelectionList(props) {
  const {
    title,
    children
  } = props;
  const {
    selectMenuGroupListRef
  } = useContext(SelectMenuContext);
  return /*#__PURE__*/React.createElement("li", {
    className: styles['sib-selectmenu-option-group-header'],
    role: "presentation"
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: styles['sib-selectmenu-option-group__header-title'],
    id: `sibSelectMenuOption${title.replace(/ /g, '')}`
  }, title) : null, /*#__PURE__*/React.createElement("ul", {
    ref: selectMenuGroupListRef,
    className: styles['sib-selectmenu-option-group__header-content'],
    role: "group",
    "aria-labelledby": `sibSelectMenuOption${title === null || title === void 0 ? void 0 : title.replace(/ /g, '')}`
  }, children));
}
GroupSelectionList.defaultProps = {
  title: ''
};
GroupSelectionList.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};
export default GroupSelectionList;